import * as api from '../../../../api';

import { Formik, FormikProps } from 'formik';
import { Box, Modal, VStack, Button } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

import {
  buildEmergencyContact,
  generateTranslatedErrorMessage,
} from '../utils';
import {
  EditEmergencyContactSchema,
  EditEmergencyContactValues,
  AddEmergencyContactValues,
} from './schema';
import { EmergencyContactFields } from './EmergencyContactFields';

interface EmergencyContactModalProps {
  topLabel: string;
  isOpen: boolean;
  emergencyContacts: api.Previsit.PatientEmergencyContact[];
  emergencyContactRelationships: api.Patient.EmergencyContactRelationship[];
  isEditExperience?: boolean;
  onModalClose: () => void;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  startsAtOne: boolean;
}

const AddEmergencyContactModal = (props: EmergencyContactModalProps) => {
  const {
    topLabel,
    onModalClose,
    isOpen,
    saveFieldValue,
    emergencyContacts,
    updateFieldValue,
    emergencyContactRelationships,
    startsAtOne,
  } = props;

  const { t } = useTranslation('emergencyContacts');

  const initialValues: AddEmergencyContactValues = {
    firstName: '',
    lastName: '',
    cellPhoneNumber: null,
    homePhoneNumber: null,
    rank: startsAtOne ? emergencyContacts.length + 1 : emergencyContacts.length,
    emergencyContactRelationshipToPatient: '',
    patientRelationshipToEmergencyContact: null,
    status: api.Previsit.ModificationStatus.Added,
    isMobile: false,
    isHome: false,
  };

  const handleSubmit = (
    values: AddEmergencyContactValues | EditEmergencyContactValues,
  ) => {
    const updatedContact = buildEmergencyContact(
      values as EditEmergencyContactValues,
    );

    emergencyContacts[startsAtOne ? values.rank - 1 : values.rank] =
      updatedContact;

    saveFieldValue(JSON.stringify(emergencyContacts));
    updateFieldValue(JSON.stringify(emergencyContacts));
    onModalClose();
  };

  const generateErrorMessages = generateTranslatedErrorMessage(t);

  return (
    <Modal
      open={isOpen}
      size="large"
      title={topLabel}
      isFullScreenOnMobile
      onClose={() => onModalClose()}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={EditEmergencyContactSchema(generateErrorMessages)}
      >
        {(formikProps: FormikProps<AddEmergencyContactValues>) => {
          return (
            <Box flexDirection={'column'}>
              <VStack gap={20}>
                <EmergencyContactFields
                  formikProps={formikProps}
                  emergencyContactRelationships={emergencyContactRelationships}
                />
                <Button
                  variant="primary"
                  fullWidth
                  onClick={formikProps.submitForm}
                >
                  {t('addEmergencyContact')}
                </Button>
              </VStack>
            </Box>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddEmergencyContactModal;
